import request from "../utils/request";
import SalesIDRetriever from "../utils/SalesIDRetriever";
import { getSessionId, getSystemSettings, getSpotlioSessionId, setTimestamp, getCartImages, setCartImages, setDestination } from "../utils/SettingsRetriever";
import { gtmFunction } from '../utils/ga';

import { store } from "../store/configureStore";

const baseParams = (parameters, extra = {}) => {
  let params = {
    ...parameters,
    id: getSystemSettings().id,
    sessionId: getSessionId(),
    salesId: SalesIDRetriever()
  }

  if(getSystemSettings().spotlioSession){
    params.uuid = getSpotlioSessionId()
  }
  
  if (getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.viewMode === "lines"){
    params.group = 0
  } else {
    params.group = 1
  }

  if(extra.group) params.group = extra.group;
  if(extra.bundle) params.bundle = extra.bundle;
  
  // always query with bundle relationship
  params.bundle = 1;

  return params;
}

const getStoreState = () => {
  let state = store.getState();
  return state.cart;
}

export const emptyCart = (extras) => {
  store.dispatch({type: "SET_CART_RESPONSE", value: null});
  store.dispatch({type: "SET_CART_STATUS", value: false});
  store.dispatch({type: "SET_DEPSCH_STATUS", value: false});
  setCartImages([]);
}

export const getItinerary = (extras) => {
  return new Promise((resolve, reject) => {
    const state = getStoreState();

    if (state.cart.queried && !extras.reload) {
      resolve(state.cart.response);
      return;
    }

    let params = baseParams({}, extras);

    request({
      url: getSystemSettings().api + "/cart",
      method: "POST",
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        setTimestamp(new Date().getTime())
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: true });
        store.dispatch({ type: "SET_CART_RESPONSE", value: res });
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
};

export const getDepositSchedule = (extras) => {
  return new Promise((resolve, reject) => {
    const state = getStoreState();
    if (state.depositSchedule.queried && !extras.reload) {
      resolve(state.depositSchedule.response);
    }

    let params = baseParams({}, {});

    request({
      url: getSystemSettings().api + "/inntopia/cart/depositSchedule",
      method: "POST",
      data: params
    })
      .then((data) => {
        if (data.status >= 200 && data.status <= 299) {
          const res = data.data;
          store.dispatch({ type: "SET_DEPSCH_STATUS", value: true });
          store.dispatch({ type: "SET_DEPSCH_RESPONSE", value: res });
          resolve(res);
        }
      })
      .catch(() => {
        reject(false);
      });
  });
}

export const add = ({ itineraryitems, productWithFullInfo, pageTitle }) => {
  return new Promise((resolve, reject) => {
    let params = baseParams();
    params.itineraryitems = itineraryitems;
    request({
      url: getSystemSettings().api + '/inntopia/cart/add',
      method: 'POST',
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        const currentImages = getCartImages() || [];
        currentImages.push({ 
          SupplierId: productWithFullInfo.SupplierId,
          ProductId: productWithFullInfo.ProductId,
          Image: productWithFullInfo.Image ? productWithFullInfo.Image.FileName : ""
        });
        setCartImages(currentImages)
        gtmFunction("addToCart", [productWithFullInfo], false, pageTitle)
        resolve(res);
      }
    })
    .catch((err) => {
      reject(false);
    });
  });
}

export const load = (parameters) => {
  return new Promise((resolve, reject) => {
    let params = baseParams(parameters, {});

    request({
      url: getSystemSettings().api + '/inntopia/cart/load',
      method: 'POST',
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const addFlight = (parameters) => {
  return new Promise((resolve, reject) => {
    request({
      url: getSystemSettings().api + "/inntopia/flights/add",
      method: "POST",
      data: parameters
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(data.status);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const addPackage = ({ itineraryitems, packageId, productWithFullInfo, section }) => {
  return new Promise((resolve, reject) => {
    let params = baseParams();
    params.itineraryitems = itineraryitems;
    params.packageId = packageId;
    request({
      url: getSystemSettings().api + '/inntopia/cart/addPackage',
      method: 'POST',
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        const currentImages = getCartImages() || [];
        productWithFullInfo.forEach(prod => {
          if (prod.ProductCategoryId === 1 && prod.Image) {
            currentImages.push({ 
              SupplierId: prod.SupplierId,
              ProductId: prod.ProductId,
              Image: prod.Image.FileName 
            });
          }
        })
        
        setCartImages(currentImages);
        gtmFunction("addToCart", productWithFullInfo, section, section);
        resolve(res);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const addBundle = ({ itineraryitems, itineraryItemId, productBundleId, productWithFullInfo }) => {
  return new Promise((resolve, reject) => {
    let params = baseParams();
    params.itineraryitems = itineraryitems;
    params.itineraryItemId = itineraryItemId;
    params.productBundleId = productBundleId;

    request({
      url: getSystemSettings().api + '/inntopia/cart/addBundle',
      method: 'POST',
      data: params
    })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(res);
        gtmFunction("addToCart", productWithFullInfo, false)
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const remove = ({ itemId, productWithFullInfo, isLast = true, pageTitle }) => {
  return new Promise((resolve, reject) => {
    let params = baseParams();
    params.itemId = itemId;

    request({
      url: getSystemSettings().api + '/inntopia/cart/remove',
      method: 'POST',
      data: params
  })
    .then((data) => {
      if (data.status >= 200 && data.status <= 299) {
        const res = data.data;
        store.dispatch({ type: "SET_DEPSCH_STATUS", value: false });
        store.dispatch({ type: "SET_CART_STATUS", value: false });
        resolve(res);
        if (isLast) gtmFunction("removeFromCart", [productWithFullInfo], false, pageTitle);
      }
    })
    .catch(() => {
      reject(false);
    });
  });
}

export const getCartImage = (item) => {
  const cartImages = getCartImages();
  let cartImage = undefined
  if (Array.isArray(cartImages) && getSystemSettings().app && getSystemSettings().app.cart.showImages) {
      cartImages.forEach(prod => {
          if (prod.SupplierId === item.SupplierId && prod.ProductId === item.ProductId) {
              cartImage = prod.Image;
          }
      })
  }
  
  if (cartImage) return cartImage;
  return false;
}

export const retrieveDestinationFromCart = (cart = []) => {
  const system = getSystemSettings();
  if (system.multiDestination && system.multiDestination.enabled){
    const destinations = [];
    cart.forEach(agrupation => {
      if (agrupation && agrupation.items) {
        agrupation.items.forEach(item => {
          const destinationToAdd = system.multiDestination.list.find(destination => destination.name === item.SupplierName);
          if (destinationToAdd) destinations.push(destinationToAdd.id);
        })
      }
    })
    if (destinations.length) setDestination(destinations);
  }
  return;
}